import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = { class: "flex flex-col p-3 gap-y-3" }
const _hoisted_2 = { class: "flex flex-row gap-2 items-center pb-1" }
const _hoisted_3 = { class: "flex gap-x-1 items-center" }
const _hoisted_4 = { class: "font-medium" }
const _hoisted_5 = { class: "grid grid-cols-2 gap-x-2 gap-y-3 items-start" }
const _hoisted_6 = { class: "flex flex-col gap-1 w-full mt-2" }
const _hoisted_7 = {
  key: 0,
  class: 
                'text-red-lp-100 text-12px xxl:text-14px pl-1 py-1 flex gap-x-2 bg-red-lp-1100 rounded-lg my-2'
              
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "flex space-x-1 items-center" }
const _hoisted_11 = { class: "w-full flex flex-col text-12px" }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Title = _resolveComponent("Title")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_SelectCustomer = _resolveComponent("SelectCustomer")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectPhoneCountry = _resolveComponent("SelectPhoneCountry")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { rounded: "xl" }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Icons, { name: "icon-detail-sender" }),
          _createVNode(_component_Title, {
            label: _ctx.$t('revamp.booking.detailSender'),
            fontSize: 14
          }, null, 8, ["label"]),
          _createVNode(_component_Chips, {
            padding: "px-2.5 py-1",
            "text-color": "text-gray-lp-800",
            color: "bg-gray-lp-1000",
            class: "rounded-full"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_Icons, {
                  name: "location-check",
                  class: "w-4"
                }),
                _createVNode("span", _hoisted_4, _toDisplayString(_ctx.districtDetail.name) + ", " + _toDisplayString(_ctx.districtDetail.cityName) + " - " + _toDisplayString(_ctx.districtDetail.originListZipCode[0]), 1)
              ])
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingShipment.column.shipperNameBookingNew'),
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectCustomer, {
                column: "Pengirim",
                placeholder: "bookingShipment.placeholder.shipperName",
                customerName: _ctx.modelValue.sender,
                "onUpdate:customerName": [
                  _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.sender = $event)),
                  _ctx.onChangeName
                ],
                loading: _ctx.loadingCustomerList,
                options: _ctx.customerList,
                keyName: "customerPhoneNumber",
                error: !!_ctx.errorMessageName,
                errorCaption: _ctx.errorMessageName,
                onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onFocusCustomer(_ctx.senderNameIndex, _ctx.modelValue.sender))),
                onSelect: _ctx.onSelectCustomer,
                disabled: _ctx.disabledName,
                isReverseJourney: _ctx.isReverseJourneyDetail,
                class: "mt-2",
                isBookingV3: true,
                useInfiniteScroll: "",
                onScrolled: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onScroll(_ctx.modelValue.sender)))
              }, null, 8, ["customerName", "onUpdate:customerName", "loading", "options", "error", "errorCaption", "onSelect", "disabled", "isReverseJourney"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingV3.shipperPhoneNumber')
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_SelectPhoneCountry, {
                  column: "Pengirim",
                  countryCodeButtonId: _ctx.countryCodeButtonId,
                  phoneNumberFieldId: _ctx.phoneNumberFieldId,
                  keyName: "customerName",
                  code: _ctx.modelValue.phoneCodeSender,
                  "onUpdate:code": [
                    _cache[4] || (_cache[4] = ($event: any) => (_ctx.modelValue.phoneCodeSender = $event)),
                    _ctx.onChangePhone
                  ],
                  phone: _ctx.modelValue.phoneSender,
                  "onUpdate:phone": [
                    _cache[5] || (_cache[5] = ($event: any) => (_ctx.modelValue.phoneSender = $event)),
                    _ctx.onChangePhone
                  ],
                  options: _ctx.customerList,
                  onSelect: _ctx.onSelectCustomer,
                  error: _ctx.errorMessagePhone,
                  isLoading: _ctx.loadingCustomerList,
                  onFocus: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onFocusCustomer(_ctx.senderPhoneIndex, _ctx.fullPhoneNumber))),
                  disabled: _ctx.disabledPhone,
                  isReverseJourney: _ctx.isReverseJourneyDetail,
                  isBookingV3: true,
                  useInfiniteScroll: "",
                  onScrolled: _cache[7] || (_cache[7] = () => _ctx.onScroll(_ctx.fullPhoneNumber))
                }, null, 8, ["countryCodeButtonId", "phoneNumberFieldId", "code", "onUpdate:code", "phone", "onUpdate:phone", "options", "onSelect", "error", "isLoading", "disabled", "isReverseJourney"]),
                (_ctx.isErrorFraudLimited || _ctx.isErrorFraudSuspected)
                  ? (_openBlock(), _createBlock("div", _hoisted_7, [
                      _hoisted_8,
                      (_ctx.isErrorFraudLimited)
                        ? (_openBlock(), _createBlock("div", _hoisted_9, [
                            _createVNode("div", _hoisted_10, [
                              _createVNode("span", null, _toDisplayString(_ctx.$t("bookingV3.senderPhone.fraud.limited1")), 1),
                              _createVNode("b", {
                                class: "underline cursor-pointer",
                                onMouseenter: _cache[8] || (_cache[8] = ($event: any) => (_ctx.toggleTooltipLimited($event))),
                                onMouseleave: _cache[9] || (_cache[9] = ($event: any) => (_ctx.toggleTooltipLimited($event)))
                              }, _toDisplayString(_ctx.$t("bookingV3.senderPhone.fraud.limited2")), 33),
                              _createVNode("span", null, _toDisplayString(_ctx.$t("bookingV3.senderPhone.fraud.limited3")), 1)
                            ]),
                            _createVNode(_component_OverlayPanel, {
                              ref: "limited",
                              appendTo: "body",
                              class: "w-1/4",
                              style: {
                    backgroundColor: '#ffffff',
                    color: '#4D4D4D'
                  }
                            }, {
                              default: _withCtx(() => [
                                _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("bookingV3.senderPhone.fraud.limitedTooltip")), 1)
                              ]),
                              _: 1
                            }, 512)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isErrorFraudSuspected)
                        ? (_openBlock(), _createBlock("p", _hoisted_12, _toDisplayString(_ctx.$t("bookingV3.senderPhone.fraud.suspected")), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingV3.shipperAddress'),
            class: "col-span-2 w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                id: "field_address_sender_booking",
                type: "textarea",
                preventEnterTextArea: "",
                showMaxLength: "",
                textAreaRows: "1",
                modelValue: _ctx.modelValue.addressSender,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.modelValue.addressSender = $event)),
                error: !!_ctx.errorMessageAddress,
                "error-caption": _ctx.errorMessageAddress,
                format: _ctx.replaceNewLine,
                placeholder: "bookingShipment.placeholder.shipperAddress",
                maxLength: _ctx.maxAddressLength,
                onFocus: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onSelectCurrentIndex(_ctx.senderAddressIndex))),
                onChange: _ctx.onValidateAddress,
                disabled: _ctx.disabledAddress,
                disableBackground: _ctx.disabledAddress,
                pbTextAreaWithLength: "pb-7"
              }, null, 8, ["modelValue", "error", "error-caption", "format", "maxLength", "onChange", "disabled", "disableBackground"])
            ]),
            _: 1
          }, 8, ["label"]),
          (_ctx.isShowSaveSender)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: 
            `${
              _ctx.disabledSaveAddress
                ? 'p-field-checkbox-grey cursor-not-allowed'
                : 'p-field-checkbox'
            } flex items-center gap-x-2.5 relative`
          
              }, [
                _createVNode(_component_Checkbox, {
                  id: "checkbox_detail_sender_booking",
                  modelValue: _ctx.modelValue.isSaveSender,
                  "onUpdate:modelValue": [
                    _cache[12] || (_cache[12] = ($event: any) => (_ctx.modelValue.isSaveSender = $event)),
                    _cache[13] || (_cache[13] = ($event: any) => (_ctx.onSelectCurrentIndex(_ctx.saveSenderIndex)))
                  ],
                  binary: "",
                  disabled: _ctx.disabledSaveAddress
                }, null, 8, ["modelValue", "disabled"]),
                _createVNode("label", {
                  for: "sender",
                  class: [{ 'text-gray-lp-500': false }, "text-sm text-black-lp-300"]
                }, _toDisplayString(_ctx.$t("bookingShipment.column.saveSender")), 1)
              ], 2))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}